import styled from '@emotion/styled'

export const UpdateRepWrapper = styled.div`
  display: flex;
  margin: 16px;
`

export const UpdateRepInput = styled.input`
  height: 18px;
  margin: 0;
  width: 18px;
`

export const UpdateRepLabel = styled.p`
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -webkit-text-decoration: none;
  color: #3c4043;
  display: block;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: .25px;
  line-height: 18px;
  margin: 0 8px;
  opacity: 1;
  text-decoration: none;
  text-transform: none;
`
